import { DateTime } from 'luxon';
import { ApplicationResponse } from '../ApplicationResponsesCell';

export type PendingRequestsEndpoint = 'activity-applications' | 'activity-waitlistings';

export type PendingRequestOrderBy = 'name' | 'email' | 'date';

export interface PendingRequestAnswer {
  answerId: string;
  answer: string;
  questionId: string;
  label: string;
}

export interface PendingRequestRow {
  id: string;
  date: string;
  volunteerId: string;
  privilegeLevel: string;
  profileId: string;
  userId: string;
  firstName: string;
  lastName: string;
  preferredName: string;
  email: string;
  contactNumber: string;
  avatarUrl: string | null;
  activityId: string;
  activityName: string;
  activityPriority: boolean;
  maxTeam: number | null;
  totalEnrolments: number;
  programId: string;
  programName: string;
  answers: PendingRequestAnswer[];
}

export interface PendingRequestsFilterOptions {
  programs: Array<{ programId: string; name: string }>;
  activities: Array<{ activityId: string; name: string; programId: string }>;
}

export interface PendingRequestsResponse {
  total: number;
  items: PendingRequestRow[];
  filterOptions: PendingRequestsFilterOptions;
}

export interface PendingRequestFilters {
  query: string;
  programIds: string[];
  activityIds: string[];
  dateFrom: string | null;
  dateTo: string | null;
}

export const PENDING_REQUESTS_PAGE_SIZE = 25;

export const DEFAULT_PENDING_REQUEST_FILTERS: PendingRequestFilters = {
  query: '',
  programIds: [],
  activityIds: [],
  dateFrom: null,
  dateTo: null,
};

export const getVolunteerName = (row: PendingRequestRow) => `${row.preferredName} ${row.lastName}`;

export const getRequestDate = (row: PendingRequestRow) => DateTime.fromISO(row.date);

export const toApplicationResponses = (row: PendingRequestRow): ApplicationResponse[] =>
  row.answers.map((answer) => ({
    answer: answer.answer,
    question: { activityApplicationQuestionId: answer.questionId, label: answer.label },
  }));
